export function decodeURIComponentSafe(s: string) {
  if (!s) {
    return s;
  }
  return decodeURIComponent(s.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'));
}

export function isClient() {
  return typeof window === 'object';
}

export function isApiAvailable(api: string) {
  return isClient() ? api in window : false;
}

function getUserAgent() {
  if (!isClient()) return '';
  return navigator.userAgent || navigator.vendor || (window as any).opera || '';
}

function getPlatform() {
  if (!isClient()) return '';
  return navigator.platform || '';
}

export function checkIfIE(): boolean {
  if (!isClient()) return false;
  const ua = getUserAgent();
  return /MSIE |Trident\//.test(ua);
}

export function checkIfFirefox(): boolean {
  if (!isClient()) return false;
  const ua = getUserAgent();
  return /firefox/i.test(ua);
}

export function checkIfSafari(): boolean {
  if (!isClient()) return false;
  const ua = getUserAgent();
  return /^((?!chrome|android|crios|fxios|edg|opr).)*safari/i.test(ua);
}

export function checkIfEdge(): boolean {
  if (!isClient()) return false;
  const ua = getUserAgent();
  return /Edg\//i.test(ua);
}

export function checkIfChrome(): boolean {
  if (!isClient()) return false;
  const ua = getUserAgent();
  return /Chrome\//i.test(ua) && !/Edg\//i.test(ua) && !/OPR\//i.test(ua) && !/Brave\//i.test(ua);
}

export function checkIfOpera(): boolean {
  if (!isClient()) return false;
  const ua = getUserAgent();
  return /OPR\//i.test(ua);
}

export function getBrowserVersion(): number | null {
  if (!isClient()) return null;
  const ua = getUserAgent();

  let versionStr: string | undefined;

  if (checkIfIE()) {
    versionStr = ua.match(/(?:MSIE |rv:)([\d.]+)/)?.[1];
  } else if (checkIfFirefox()) {
    versionStr = ua.match(/Firefox\/([\d.]+)/)?.[1];
  } else if (checkIfSafari()) {
    versionStr = ua.match(/Version\/([\d.]+).*Safari/)?.[1];
  } else if (checkIfEdge()) {
    versionStr = ua.match(/Edg\/([\d.]+)/)?.[1];
  } else if (checkIfChrome()) {
    versionStr = ua.match(/Chrome\/([\d.]+)/)?.[1];
  } else if (checkIfOpera()) {
    versionStr = ua.match(/OPR\/([\d.]+)/)?.[1];
  }

  if (!versionStr) return null;

  const majorVersion = parseInt(versionStr.split('.')[0], 10);
  return Number.isNaN(majorVersion) ? null : majorVersion;
}

const MIN_SUPPORTED_SAFARI_VERSION = 14;
export function isOutdatedBrowser() {
  if (checkIfIE()) return true;

  if (checkIfSafari()) {
    const version = getBrowserVersion();
    return version && version <= MIN_SUPPORTED_SAFARI_VERSION;
  }

  return false;
}

// Mobile

export function checkIfMobile() {
  if (!isClient()) return true;

  const ua = getUserAgent();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);
}

export function checkIfAndroid() {
  if (!isClient()) return false;
  const ua = getUserAgent();
  return /Android/i.test(ua);
}

export function checkIfIOS() {
  if (!isClient()) return false;

  const platform = getPlatform();
  const ua = getUserAgent();
  const hasTouch = navigator.maxTouchPoints > 0;

  return (
    /iPhone|iPad|iPod/.test(platform)
    || (/iPhone|iPad|iPod/.test(ua) && /like Mac OS X/.test(ua))
    || (platform === 'MacIntel' && hasTouch)
  );
}
